/* eslint-disable no-unused-vars */
import { useId, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Label, CustomTooltip, ChooseCreativeImage, Buttons, ImageWithFallback } from 'components';
import { Question, DeleteIcon } from 'assets/icons';
import * as S from './UploadImage.styled';
import { useComputed, useSignal } from '@preact/signals-react';
import { manageCreativeMediaAPI } from 'services/manageCreativeMedia.service';

const toolTipStyle = {
  color: '#64748B',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '16px',
};

const labelStyle = { marginLeft: 'auto', marginRight: '8px' };

const checkImgData = (iconData) => {
  if (!iconData) return '';
  if (iconData.includes('base64')) {
    return iconData;
  } else {
    return `https://cdn.appnext.com/banner/${iconData}`;
  }
};

export const UploadImage = ({
  previewSectionImage$,
  currentSelectedSize$,
  detectWidthAndHeight,
  isDisabled,
}) => {
  const btnId = useId();
  const isOpen$ = useSignal(false);

  const pba_id = useSelector((state) => state.creatives.creativeAndTrackingData.pba_id);
  const app_package = useSelector((state) => state.creatives.creativeAndTrackingData.app_package);

  const dataToImgFetch = useMemo(
    () => ({
      package_id: app_package,
      image_type: currentSelectedSize$.value.imageType,
      pba_id: pba_id,
    }),
    [app_package, currentSelectedSize$.value?.imageType],
  );
  const {
    data: imgList,
    isLoading,
    isFetching,
    isSuccess,
  } = manageCreativeMediaAPI.useGetCreativeImagesByTypeQuery(dataToImgFetch, {
    skip: !isOpen$.value,
  });

  const [uploadAction, uploadResult] = manageCreativeMediaAPI.useUploadCreativeImageDataMutation();

  return (
    <div>
      <S.LabelBox>
        <Label text='Upload image:' variant='label' />
        <S.Requirements isDisabled={!currentSelectedSize$.value}>
          <Label text='Requirements' variant='description' style={labelStyle} />
          <CustomTooltip
            style={toolTipStyle}
            content={<Question />}
            text={<TooltipText currentSelectedSize$={currentSelectedSize$} />}
          />
        </S.Requirements>
      </S.LabelBox>
      {previewSectionImage$.value ? (
        <S.WrapForError>
          <S.ImageContainer>
            <S.IconBox>
              <S.IconWrap>
                {/* <S.DeleteBtn
                  type='button'
                  onClick={() => {
                    previewSectionImage$.value = null;
                  }}
                >
                  <DeleteIcon />
                </S.DeleteBtn> */}
                <ImageWithFallback
                  width='100%'
                  height='100%'
                  src={checkImgData(previewSectionImage$.value?.file_name)}
                />
              </S.IconWrap>
            </S.IconBox>
          </S.ImageContainer>
        </S.WrapForError>
      ) : (
        <S.ChooseFileContainer>
          <Buttons.SecondaryNormal
            id={btnId}
            name='DISABLED LIST'
            onClick={() => (isOpen$.value = true)}
            isDisabled={!currentSelectedSize$.value || isDisabled}
          >
            Choose File
          </Buttons.SecondaryNormal>
          {isOpen$.value && (
            <ChooseCreativeImage
              isOpen$={isOpen$}
              imgList={imgList}
              isLoading={isLoading}
              isFetching={isFetching}
              previewSectionImage$={previewSectionImage$}
              currentSelectedSize$={currentSelectedSize$}
              uploadAction={uploadAction}
              uploadResult={uploadResult}
              detectWidthAndHeight={detectWidthAndHeight}
            />
          )}
        </S.ChooseFileContainer>
      )}
    </div>
  );
};

const TooltipText = ({ currentSelectedSize$ }) => {
  if (!currentSelectedSize$.value) return null;

  return (
    <p style={{ maxWidth: '150px' }}>
      JPEG or PNG. Please upload image size {currentSelectedSize$.value.imageSize}. You can also
      upload different image size and adjust it.
    </p>
  );
};
